import { createStore } from 'zustand'

import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'

import {
  PriceCompareListStore,
  PriceCompareListStoreOptions
} from './interface'

export const createPriceCompareListStore = ({
  tableRef
}: PriceCompareListStoreOptions) =>
  createStore<PriceCompareListStore>((set, get) => ({
    tableRef,
    currentPriceCompare: undefined,
    setCurrentPriceCompare(priceCompare) {
      set({ currentPriceCompare: priceCompare })
    },
    detailFormMode: FormMode.READ,
    setDetailFormMode(mode) {
      set({ detailFormMode: mode })
    },
    detailFormVisible: false,
    toggleDetailFormVisible(visible) {
      const detailFormVisible = visible ?? !get().detailFormVisible

      set({ detailFormVisible })

      if (!detailFormVisible) {
        set({ detailFormMode: FormMode.READ })
      }
    },
    bidMemberListModalVisible: false,
    toggleBidMemberListModalVisible(visible) {
      set({
        bidMemberListModalVisible: visible ?? !get().bidMemberListModalVisible
      })
    },
    bidRecordListModalVisible: false,
    toggleBidRecordListModalVisible(visible) {
      set({
        bidRecordListModalVisible: visible ?? !get().bidRecordListModalVisible
      })
    },
    bidRecordConfirmModalVisible: false,
    toggleBidRecordConfirmModalVisible(visible) {
      set({
        bidRecordConfirmModalVisible:
          visible ?? !get().bidRecordConfirmModalVisible
      })
    }
  }))
